import { Table } from "reactstrap";
import InvoiceThreeHeader from "./InvoiceThreeHeader";
import InvoiceClientDetail from "./InvoiceClientDetail";
import InvoiceThreeTable from "./InvoiceThreeTable";
import InvoiceBankTransfer from "./InvoiceBankTransfer";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import { useRef } from "react";

const InvoiceThreeContainer = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <div ref={contentRef}>
        <Table style={{ width: "1075px", margin: "0 auto", background: "#fff" }} borderless>
          <tbody style={{ padding: "10px" }}>
            <tr>
              <InvoiceThreeHeader />
            </tr>
            <tr>
              <InvoiceClientDetail />
            </tr>
            <tr>
              <td>
                <span style={{ display: "block", background: "rgba(82, 82, 108, 0.3)", height: 1, width: "100%", marginBottom: 20 }}></span>
              </td>
            </tr>
            <tr>
              <InvoiceThreeTable />
            </tr>
            <tr>
              <InvoiceBankTransfer />
            </tr>
            <tr>
              <td>
                <span style={{ display: "block", background: "rgba(82, 82, 108, 0.3)", height: 1, width: "100%", marginBottom: 30 }} />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
      <InvoiceButtons contentRef={contentRef} />
    </>
  );
};

export default InvoiceThreeContainer;
